import script from "./WaizmannWertHeil.vue?vue&type=script&setup=true&lang=js"
export * from "./WaizmannWertHeil.vue?vue&type=script&setup=true&lang=js"

import "./WaizmannWertHeil.vue?vue&type=style&index=0&id=4cd7467a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd7467a"]])

export default __exports__